module.exports = __webpack_public_path__ + "static/media/trimex_san marcos asmsa.a110d0cb.png";